export class DataAccessError extends Error {
  public _tag: "DataAccessError"

  public reason: string

  private constructor(reason: string) {
    super(reason)
    this._tag = "DataAccessError"
    this.reason = reason
  }

  public static of(reason: string) {
    return new DataAccessError(reason)
  }
}
